import PropTypes from 'prop-types';
import React from 'react';


function _getTitleText({ text, area, categoryLiteral, titlePreposition, city, t }) {
  if (text) return `${text} `;
  if (area) return `${t("{area} {titlePreposition} m² {type}", { area, titlePreposition, type: categoryLiteral })} `;
  return `${t("{type} {titlePreposition} {city}", { city, titlePreposition, type: categoryLiteral })} `;
}

export default function Title({ text, area, categoryLiteral, titlePreposition, city, className, handleOnClick, isFirefox, t }) {
  return (
    <span className={ `${className} ${isFirefox ? '-firefox-clamp' : ''}` } onClick={ handleOnClick }>
      { isFirefox
        ? (
          <p className="establishment-info">
            { `${_getTitleText({ area, categoryLiteral, city, t, text, titlePreposition })} ` }
          </p>
        )
        : _getTitleText({ area, categoryLiteral, city, t, text, titlePreposition })
      }
    </span>
  );
}

Title.defaultProps = {
  area: null,
  categoryLiteral: null,
  city: null,
  className: 'title',
  handleOnClick: () => {},
  isFirefox: false,
  text: null,
  titlePreposition: null,
};

Title.propTypes = {
  area: PropTypes.number,
  categoryLiteral: PropTypes.string,
  city: PropTypes.string,
  className: PropTypes.string,
  handleOnClick: PropTypes.func,
  isFirefox: PropTypes.bool,
  t: PropTypes.func.isRequired,
  text: PropTypes.string,
  titlePreposition: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
